import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        A new Student Centre has been created within the courtyards of Long Road
        Sixth Form College by remodelling a redundant, isolated block.
      </p>
      <p>
        The building not only allows students a place to rest and relax between
        lessons, the open-plan layout is also used for student functions and
        open-days.
      </p>
      <p className="ps">
        This project was completed while Matt was with RH Partnership Architects
        in Cambridge. Images courtesy of RH Partnership.
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/long-road-student-centre.jsx